import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Removes one level of a Unit Upgrade track; the later levels move up. A player who had completed more
// levels than the track now has keeps only the bonus of the levels left (SimUpgrades reads what exists).
export class RemoveUnitUpgradeLevelCommand extends CommandBase {
    uid: string;
    index: number;

    constructor(uid: string, index: number) {
        super();
        this.uid = uid;
        this.index = index;
    }

    execute(data: RemoteConstantsModel): boolean {
        const track = data.unitUpgrades?.find(t => t.uid === this.uid);
        if (!track || this.index < 0 || this.index >= track.levels.length) return false;
        track.levels = track.levels.filter((_, i) => i !== this.index);
        return true;
    }
}
